import React from "react"
import { useTranslation } from "react-i18next"

import { useUser } from "hooks"

import { UploadedDocument, DocumentsTypes, Bike } from "models"
import { FileList } from "./Partials/FileList"
import { Markdown } from "components/Elements"

export type BikeDocumentsProps = {
	bike: Bike
	documents: UploadedDocument[]
	refreshDocuments: () => Promise<void>
}

export const BikeDocuments: React.FC<BikeDocumentsProps> = ({
	bike,
	documents,
	refreshDocuments,
}) => {
	const { user } = useUser()
	const { t } = useTranslation()

	return (
		<>
			<FileList
				id={"invoice"}
				name={"invoice"}
				label={t("description.invoice", { ns: "bike" })}
				buttonClassName="mb-3"
				files={documents}
				refreshFiles={refreshDocuments}
				filesType={DocumentsTypes.FACTURE}
				maxFilesToUpload={1}
				payloadData={{
					bike_id: bike.bike_id,
					account_id: user.account_id,
				}}
			/>

			<FileList
				id={"other-attachments"}
				name={"other-attachments"}
				label={t("description.other_attachments", {
					ns: "bike",
				})}
				buttonClassName="mb-3"
				files={documents}
				refreshFiles={refreshDocuments}
				filesType={DocumentsTypes.AUTRE}
				maxFilesToUpload={1}
				payloadData={{
					bike_id: bike.bike_id,
					account_id: user.account_id,
				}}
			/>
			<div className="text-xxs mt-2">
				<Markdown>{t("documents.other_format", { ns: "bike" })}</Markdown>
			</div>
		</>
	)
}
